// axiosJWT.js
import Axios from 'axios';
import getCookie from './getCookies';
import isTokenExpired from './isTokenExpired';
import { StopLoading } from '../Utils/loadingUtils';
import { showToast } from '../Utils/toastUtils';
import Logout from './Logout';


const axiosJWT = Axios.create();

// 🔹 Navigate store karne ke liye variable & export function
let navigateFn = null;
export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

// 🔹 Logout control flag
let isLoggingOut = false;

// function handleLogout() {
//   if (isLoggingOut) return; // Already logout in progress
//   isLoggingOut = true;
//   // StopLoading();
//   if (navigateFn) {
//     Logout(navigateFn); // navigate pass to Logout
//   } else {
//     console.error('navigateFn is not set. Call setNavigate(navigate) in your App.js');
//   }
// }

const handleLogout = async () => {
  await Axios.post(`${process.env.REACT_APP_API_URL}/api/LogOut`, {}, { withCredentials: true });
  // window.location.href = "/"; 10-9-25
  // window.location.reload();
}

// ✅ Request Interceptor
axiosJWT.interceptors.request.use(
  async (config) => {
    // const token = getCookie('accessToken');
    // console.log('token is' + token);
    // if (token && !isTokenExpired(token)) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    // StopLoading();
    return Promise.reject(error);
  }
);

// ✅ Response Interceptor
axiosJWT.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Network / CORS error
    if (!error.response) {
      showToast('Network error. Please try again.', 'error');
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    const status = error.response.status;

    // 🔹 401 Handling
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // const refreshToken = getCookie('refreshToken');
      // console.log('refreshToken' + refreshToken);
      // Refresh token missing or expired → logout
      // if (!refreshToken || isTokenExpired(refreshToken)) {
      //   console.log('dfjdkfjdkjfdk')
      //   // handleLogout();
      //   return Promise.reject(new Error());
      //   // return Promise.reject(new Error('Refresh token missing or expired.'));
      // }

      try {
      
        // Call refresh token API
        const res = await Axios.post(`${process.env.REACT_APP_API_URL}/api/refresh-token`,{},{ withCredentials: true });
        if (res.data.success === 1) {
        //  console.log('test success');
          return axiosJWT(originalRequest); // Retry request
        } else {
          // handleLogout();
          return Promise.reject(new Error('Unable to refresh token.'));
        }
      } catch (err) {
        // handleLogout(); // 10-9-25
        return Promise.reject(err);
      }
    }

    // 🔹 Other errors
    showToast(error.response.data?.message || 'An error occurred', 'error');
    // handleLogout();
    return Promise.reject(error);
  }
);

export default axiosJWT;
